import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  change(e) {
    Turbo.visit(e.target.value);
  }
}
